export const TRANSITION_DURATION = 300; // ms
